const isTouchDevice =
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    ("msMaxTouchPoints" in navigator && navigator.msMaxTouchPoints > 0);

const ua = navigator.userAgent || "";
const isMobileUA =
    /Android|iPhone|iPad|iPod|Mobile|Windows Phone|HarmonyOS/i.test(ua);
const isSmallScreen = Math.min(window.innerWidth, window.innerHeight) < 820;
const isLowPower = isTouchDevice && (isMobileUA || isSmallScreen);

export const device = {
    isTouchDevice,
    isLowPower,
    maxPixelRatio: isLowPower ? 1.4 : 2,
};
